function adjustMegaMenu() {
  $("section.mega-menu__section").each(function () {
    var t = $(this).offset().top;
    var height = $(window).height() - t;
    $(this).find("div.mega-menu").css("max-height", height);
  });
}

$.fn.CountDownTimer = function () {
  var elem = this;

  function updateCountdown(
    endTime,
    showSeconds = true,
    separator = ":",
    textBefore = ""
  ) {
    const now = new Date();

    // Convert current time to EST
    const estTimeNow = now.toLocaleString("en-US", {
      timeZone: "America/Detroit",
    });
    const estNow = new Date(estTimeNow);

    // Calculate the start of the current EST day
    const estMidnight = new Date(estNow);
    estMidnight.setHours(0, 0, 0, 0);

    // Calculate the next reset time
    //const nextReset = new Date(estMidnight.getTime() + 24 * 60 * 60 * 1000);
    let nextReset = new Date(estMidnight.getTime() + 24 * 60 * 60 * 1000);

    if (endTime && endTime != 0) {
      nextReset = new Date(endTime);
    }

    // Calculate remaining time
    const remainingTime = nextReset - estNow;
    const days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
    const hours = Math.floor((remainingTime / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((remainingTime / (1000 * 60)) % 60);
    const seconds = Math.floor((remainingTime / 1000) % 60);

    // Format the timer as HHh:MMm:SSs
    /*
    const formattedTime =
      (days > 0 ? `${days}d:` : ``) +
      `${hours.toString().padStart(2, "0")}h:${minutes
        .toString()
        .padStart(2, "0")}m:${seconds.toString().padStart(2, "0")}s`;
        */

    let formattedTime = [];

    if (days > 0) formattedTime.push(`${days}d`);

    formattedTime.push(`${hours.toString().padStart(2, "0")}h`);
    formattedTime.push(`${minutes.toString().padStart(2, "0")}m`);

    if (showSeconds)
      formattedTime.push(`${seconds.toString().padStart(2, "0")}s`);

    formattedTime = formattedTime.join(separator);

    // Update the timer element
    elem.find("span.timer").text(textBefore + " " + formattedTime);
  }

  var endTime = elem.data("end");
  var showSeconds = elem.data("show_seconds");
  var separator = elem.data("separator");
  var textBefore = elem.data("text_before_timer");

  if (!separator) separator = " ";

  setInterval(() => {
    updateCountdown(endTime, showSeconds, separator, textBefore);
  }, 1000);
  updateCountdown(endTime, showSeconds, separator, textBefore);
  elem.css("opacity", 1);
};

$(document).ready(function () {
  adjustMegaMenu();

  $(window).on("resize", adjustMegaMenu);

  $(".countdown-timer").CountDownTimer();
  $("#timer").CountDownTimer();
});

/* ticket js */

$(document).ready(function () {
  $(".popup_addtocart").on("click", function () {
    $(".ticket_form_popup").css("display", "flex");
  });
  $(".ticket_popup_close").on("click", function () {
    $(".ticket_form_popup").css("display", "none");
  });
});
$(document).ready(function () {
  $(".ticket_form_popup").each(function () {
    let $popup = $(this);
    let $inputs = $popup.find(".line-item-property__field input");
    let $button = $popup.find(".popupaddto_cart_btn a");

    // Initially disable the button
    $button.css("pointer-events", "none").css("opacity", "0.5");

    $inputs.on("input", function () {
      let allFilled = true;

      $inputs.each(function () {
        if ($(this).val().trim() === "") {
          $(this).css("border", "1px solid red");
          allFilled = false;
        } else {
          $(this).css("border", "1px solid #ccc");
        }
      });

      if (allFilled) {
        $button.css("pointer-events", "auto").css("opacity", "1");
      } else {
        $button.css("pointer-events", "none").css("opacity", "0.5");
      }
    });

    // On button click - if disabled, highlight empty fields
    $button.on("click", function (e) {
      if ($button.css("pointer-events") === "none") {
        e.preventDefault(); // Stop click action if button is disabled

        $inputs.each(function () {
          if ($(this).val().trim() === "") {
            $(this).css("border", "1px solid red");
          }
        });

        return; // Stop further execution
      }

      // Hide popup smoothly and trigger submit after 1 sec
      $popup.fadeOut(300);

      let shadowContainer = document.querySelector("#app-embed");
      if (shadowContainer) {
        let shadowRoot = shadowContainer.shadowRoot || shadowContainer;
        let submitButton = $(shadowRoot).find('button[type="submit"]');

        if (submitButton.length) {
          submitButton.click();
        } else {
          console.error("Submit button not found inside the shadow DOM.");
        }
      } else {
        console.error("Shadow container not found.");
      }

      setTimeout(function () {
        $(".purchase-details__buttons button.button.ajax-submit").trigger(
          "click"
        );
        window.location.href = "/checkout";
      }, 3500);
    });
  });

  function checkSelectedSwatch() {
    const $selectedSwatch = $(
      '.swatches div[option-name="Size"] li[aria-checked="true"]'
    );

    if ($selectedSwatch.length == 0) return;

    const variant_id = $selectedSwatch.attr("option-value-id");

    if ($selectedSwatch.hasClass("swatch-item-unavailable")) {
      $notifyForm.attr("data-variant-id", variant_id);

      const size = $selectedSwatch.find(".swatch-selected").attr("data-value");
      $notifyForm.find(".notify-msg span").text(size);

      $notifyForm.show();
      $productSection.addClass("variant-unavailable");
    } else {
      $notifyForm.hide();
      $productSection.removeClass("variant-unavailable");
      $atc.show();
    }
  }

  function checkVariantStock($scope) {
    if (!$scope || !$scope.length) return;

    const variant_id = $scope.find("variant-selection").first().attr("variant");
    const $notifyForm = $scope.find("#klaviyo-notify");
    const $notifyBtn = $notifyForm.find(".notify-submit");

    if (!variant_id || !$notifyForm.length) return;

    const email = $notifyForm.find('input[type="email"]').val();

    if (email == "" || email.indexOf("@") < 0) {
      alert("Please enter a valid email address");
      return;
    }

    const payload = {
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: email,
              },
            },
          },
          channels: ["EMAIL"],
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: "$shopify:::$default:::" + variant_id,
            },
          },
        },
      },
    };

    if (!$notifyBtn.attr("data-text"))
      $notifyBtn.attr("data-text", $notifyBtn.text());

    $notifyBtn.text("Please wait...");

    var requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        revision: "2024-06-15",
      },
      body: JSON.stringify(payload),
    };

    fetch(
      "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=NjsFiz",
      requestOptions
    )
      .then((result) => {
        $notifyForm
          .find(".notify-msg")
          .removeClass("error")
          .addClass("success")
          .text("Your email has been submitted.");
        $notifyBtn.text($notifyBtn.attr("data-text"));
        $notifyForm.find('input[type="email"]').val("");
      })
      .catch((error) => {
        $notifyForm
          .find(".notify-msg")
          .removeClass("success")
          .addClass("error")
          .text("Your email has been submitted.");
        $notifyBtn.text($notifyBtn.attr("data-text"));
      });
  }

  const $productSection = $(".product_section");
  const $product = $productSection.parent();
  const $notifyForm = $("#klaviyo-notify", $product);
  const $notifyBtn = $notifyForm.find(".notify-submit");
  const $atc = $(".button--add-to-cart, .purchase-details, .reward-points");

  $(document).on("change", "variant-selection", function () { 
    setTimeout(checkSelectedSwatch, 50);
  });

  $(document).on("click", "#klaviyo-notify button", function (e) {
    e.preventDefault();

    const $scope = $(this).closest(".product_section");
    checkVariantStock($scope);
  });

  /* add to cart on quick shop */
  $(document).on("click", ".js-quick-shop [data-add-to-cart-trigger]", async function (e) {
    e.preventDefault();
    e.stopPropagation();
    let $form = $(this).closest("form");

    // get form data
    let formData = {
      'items': [{
       'id': $form.find("select[name='id']").val(),
       'quantity': $form.find("input[name='quantity']").val()
       }]
     };

     // send form data to cart/add.js
     fetch(window.Shopify.routes.root + 'cart/add.js', {
       method: 'POST',
       headers: {
         'Content-Type': 'application/json'
       },
       body: JSON.stringify(formData)
     })
     .then(response => response.json())
     .then(data => {
      // show smart cart
      Rebuy.SmartCart.show();
     })
     .catch((error) => {
       console.error('Error:', error);
     })
  });
 
  $(document).on("submit", ".refer-step form", function (e) {
    e.preventDefault();

    var nameField = $(this).find('input[name="name"]');
    var emailField = $(this).find('input[name="email"]');
    var urlField = $(this).parents(".refer-a-friend").find("input.refer-url");

    fetch("https://api.bixgrow.com/api/referral/advocates/register", {
      method: "POST",
      headers: {
        'Accept': '*/*',
        'Accept-Language': 'en-GB,en;q=0.9,en-US;q=0.8,ur;q=0.7',
        'Content-Type': 'application/json',
        'Origin': 'https://shopswankaposh.com',
        'Priority': 'u=1, i',
        'Referer': 'https://shopswankaposh.com/',
        'Sec-CH-UA': '"Google Chrome";v="135", "Not-A.Brand";v="8", "Chromium";v="135"',
        'Sec-CH-UA-Mobile': '?0',
        'Sec-CH-UA-Platform': '"macOS"',
        'Sec-Fetch-Dest': 'empty',
        'Sec-Fetch-Mode': 'cors',
        'Sec-Fetch-Site': 'cross-site',
        'User-Agent': 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/135.0.0.0 Safari/537.36',
      },
      body: JSON.stringify({
        email: emailField.val(),
        name: nameField.val(),
        shop: "swank-a-posh.myshopify.com",
        campain_id: 5194,
        locale: "en",
        enable_marketing_consent_request: 0,
      }),
    })
      .then((response) => response.json()) // Assuming response is in JSON format
      .then((data) => {
        $(this).parents(".refer-a-friend").find(".refer-step").hide();
        var $currentStep = $(this).parents(".refer-step");
        
        $currentStep.next().slideDown();
        
        urlField.val(data.advocate.link);
      })
      .catch((error) => console.error("Error:", error));
  });

  $(document).on("click", ".refer-copy", function(e) {
    e.preventDefault();

    var $btn = $(this);
    var url = $(this).parents('.refer-step').find('.refer-url').val();

    navigator.clipboard.writeText(url).then(() => {
        $btn.text('COPIED').attr('disabled', 'disabled');
    }).catch(err => {
        alert("Failed to copy url");
    });
  });

  $(document).on("click", ".refer-step button", function (e) {
    e.preventDefault();

    var $currentStep = $(this).parents(".refer-step");
    var $nextStep = $currentStep.next();

    if ($currentStep.find("form").length > 0) {
      $currentStep.find("form").submit();
    } else {
      $(this).parents(".refer-a-friend").find(".refer-step").hide();
      $nextStep.slideDown();
    }
  });

  //$('.refer-a-friend').referFriend();
});

document.addEventListener("DOMContentLoaded", function(event) {
  setTimeout(function() { 
    var knf = document.querySelector('#klaviyo-notify');
    var aftersize = document.querySelector('div[option-name="Size"]'); 
    if (knf && aftersize && aftersize.parentNode) {
      aftersize.parentNode.insertBefore(knf, aftersize.nextSibling);
    }
  }, 3000); // 5000 milliseconds = 5 seconds


$(document).on('click', '.swatches div[option-name="Size"] li', function () {
  const $clickedSwatch = $(this);

  setTimeout(function () {
    if ($clickedSwatch.attr('aria-checked') === 'true') {
      const selectedValue = $clickedSwatch.attr('orig-value');

      $('.variant-selection fieldset.swatch.size .swatch-element').each(function () {
        if ($(this).attr('data-value') === selectedValue) {
          $(this).find('label').trigger('click');
        }
      });
    }
  }, 10);
});


  
});





 

/* remove label */
function removeLabel(productElement) {
    const label = productElement.querySelector(".my-saving-labels");
    if (label) {
        label.remove();
    }
}

/* add new label */
function addLabel(productElement, data) {
    const save = Math.round((data.comparePrice - data.price) * 100 / data.comparePrice);
    const saveD = (data.comparePrice - data.price).toFixed(1); // <-- keeps one decimal
    if (productElement.querySelectorAll(`.my-saving-labels`).length === 0) {
        productElement.querySelector(".info-container").insertAdjacentHTML(
            'beforeend',
            `<div class="my-saving-labels">Save ${save}% <span>($${saveD})</span></div>`
        );
    }
}


function fshooks() {
    window.SerpOptions.registerHook("serp-product-grid", ({products, element}) => {
        console.log(products, element);
        for (const productElement of getProductElements(element)) {
            /* get product data */
            const productID = productElement.dataset.productId;
            const data = products[productID];

            /* clear product */
            removeLabel(productElement);

            /* add if comparePrice exist*/
            if( parseFloat(data.comparePrice) > 0 && parseFloat(data.comparePrice) > parseFloat(data.price) ){
                addLabel(productElement, data)
            }
        }
    });
}

// execution here
if (window.SerpOptions) {
    fshooks();
} else {
    window.addEventListener('fast-serp-ready', function () {
        fshooks();
    });
}

